import { render, staticRenderFns } from "./OverlayScreen.vue?vue&type=template&id=1cd48bc8&scoped=true&"
import script from "./OverlayScreen.vue?vue&type=script&lang=js&"
export * from "./OverlayScreen.vue?vue&type=script&lang=js&"
import style0 from "./OverlayScreen.vue?vue&type=style&index=0&id=1cd48bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd48bc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ui-spec-md/ui-spec-md/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1cd48bc8', component.options)
    } else {
      api.reload('1cd48bc8', component.options)
    }
    module.hot.accept("./OverlayScreen.vue?vue&type=template&id=1cd48bc8&scoped=true&", function () {
      api.rerender('1cd48bc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/OverlayScreen.vue"
export default component.exports